// Each page's description for search results (<meta name="description">), by route name (see
// ./index.js). A string, or a function of the route's params ({year, …}). Aim for 120–160
// characters. Pages without an entry use DEFAULT_DESCRIPTION. Pages with their own content
// (a news item, a video) set theirs with setPageMeta (src/composables/usePageMeta.js).

export const DEFAULT_DESCRIPTION =
  "VIZBI is an international community bringing together scientists, illustrators, and " +
  "designers who visualize biological data, with an annual conference since 2010.";

export const pageDescriptions = {
  // site-wide pages
  About:
    "About VIZBI: an international initiative bringing together researchers, medical " +
    "illustrators, and designers who visualize biological data.",
  Showcases:
    "VIZBI Showcases: public events exploring how visualization, animation, and art " +
    "communicate the life sciences to wider audiences.",
  "News Year": ({year}) =>
    `VIZBI news from ${year}: announcements, highlights, and updates from the international ` +
    "community visualizing biological data.",
  Collective:
    "The VIZBI Collective: scientists, animators, and visual artists producing animations, " +
    "projection mappings, and live events about the life sciences.",
  Photos: "Photos from VIZBI conferences, Showcases, and events since 2010.",
  Terms: "Terms and conditions for VIZBI conferences, registration, and website use.",
  Videos_Gallery:
    "Videos of talks and Masterclass sessions from VIZBI conferences: leading experts on " +
    "visualizing biological data.",
  Videos_Year: ({year}) =>
    `Videos of talks from VIZBI ${year}: leading experts on visualizing biological data.`,
  Videos_Session: ({session}) =>
    `Videos of VIZBI talks on ${session}: leading experts on visualizing biological data.`,
  Videos_Unlock: "Unlock the full library of VIZBI talk videos.",
  Videos_Unlock_Masterclass:
    "The speakers of the VIZBI DataVis Masterclass: unlock all their talk videos.",
  // VizbiPlus
  VizbiPlus:
    "VizbiPlus (2012–2017) trained science animators to create accurate, inspiring " +
    "animations of cutting-edge biomedical research.",
  "VizbiPlus About": "About VizbiPlus: Visualising the Future of Biomedicine (2012–2017).",
  "VizbiPlus People": "The people behind VizbiPlus: Visualising the Future of Biomedicine.",
  "VizbiPlus Challenge": "The VizbiPlus Challenge: animations communicating biomedical research.",
  "VizbiPlus Timeline": "Timeline of VizbiPlus: Visualising the Future of Biomedicine.",
  "VizbiPlus Contact": "Contact the VizbiPlus team.",
  "VizbiPlus Events": "Events run by VizbiPlus: Visualising the Future of Biomedicine.",
  // one year's conference
  AboutYear: ({year}) =>
    `VIZBI ${year}: the international meeting on visualizing biological data, with a ` +
    "Workshop, Masterclass, Showcase, posters, and art.",
  People: ({year}) => `Speakers, organizers, and contributors at VIZBI ${year}.`,
  Program: ({year}) => `The program for VIZBI ${year}: talks, sessions, and events.`,
  Contact: ({year}) => `Contact the organizers of VIZBI ${year}.`,
  Masterclass: ({year}) =>
    `The VIZBI ${year} Masterclass: a one-day course on data visualization for life scientists.`,
  Showcase: ({year}) =>
    `The VIZBI ${year} Showcase: an evening exploring how visualization, animation, and art ` +
    "communicate the life sciences.",
  Photos_Year: ({year}) => `Photos from VIZBI ${year}.`,
  Sponsors: ({year}) => `The sponsors and partners supporting VIZBI ${year}.`,
  Registration: ({year}) => `Registration Fees and how to register for VIZBI ${year}.`,
  Venue: ({year}) => `The venue for VIZBI ${year}: location, travel, and accommodation.`
};

export function getPageDescription(route) {
  const description = pageDescriptions[route.name];
  if (!description) return DEFAULT_DESCRIPTION;
  return typeof description === "function" ? description(route.params) : description;
}
